import { getErrorMessage } from '@/utils/helpers'

import axios from './instance'

/**
 * Gets the list of global proficiency questions.
 */
export const getGlobalProficiencyQuestions = async () => {
  try {
    return await axios.get('/global-proficiency-questions?limit=100')
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}
